/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellularAlt: {
  name: 'signal-cellular-alt';
  data: string;
} = {
  name: 'signal-cellular-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z"/></svg>`
};
